import { SVGProps } from 'react';

const ArrowLeftRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 11 4 7l4-4M4 7h16m-4 6 4 4-4 4m4-4H4"
    />
  </svg>
);
export default ArrowLeftRight;
